import axios from "../plugins/parseAxios";
export class AreaInterestAPI {
  static getAreaInterest(payload) {
    return axios.post("/functions/getAreaInterest", payload);
  }
  // create
  static createAreaInterest(payload) {
    return axios.post("/functions/createAreaInterest", payload);
  }
  // update
  static updateAreaInterest(payload) {
    return axios.post("/functions/updateAreaInterest", payload);
  }
  // areaInterests
  static getAreaInterests(payload) {
    return axios.post("/functions/getAreaInterests", payload);
  }
  static updateAreaInterestStatus(payload) {
    return axios.post("/functions/updateAreaInterestStatus", payload);
  }
  static approveAreaInterest(payload) {
    return axios.post("/functions/approveAreaInterest", payload);
  }
  static rejectAreaInterest(payload) {
    return axios.post("/functions/rejectAreaInterest", payload);
  }
  static getAreaInterestByArea(payload) {
    return axios.post("/functions/getAreaInterestByArea", payload);
  }
}
